import FormControlLabel from '@mui/material/FormControlLabel';
import React from "react";
import {Switch} from "@mui/material";

interface BooleanSwitchProps {
    value?: boolean;
    label: string;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    required?: boolean;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom'
}

export const BooleanSwitch = ({
                                  value = false,
                                  label,
                                  onChange,
                                  disabled = false,
                                  labelPlacement = 'top'
                              }: BooleanSwitchProps) => (
    <FormControlLabel
        labelPlacement={labelPlacement}
        control={
            <Switch
                sx={{margin:0}}
                checked={Boolean(value)}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            />
        }
        label={label}
    />
);
